<template>
  <div>
    <el-input size="mini" placeholder="请输入" :value="value" @input="input">
      <el-button
        slot="append"
        icon="el-icon-edit-outline"
        title="编辑"
        @click="visible = true"
        :style="{ color: '#fff', fontSize: '18px' }"
      ></el-button>
    </el-input>
    <el-dialog
      v-drag:common
      title="风电标杆/指导电价(元/千瓦时)"
      :visible.sync="visible"
    >
      <el-table :data="data">
        <el-table-column
          v-for="col in columns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
// 电价
// import isEmpty from 'lodash/isEmpty';
import groupBy from 'lodash/groupBy';

export default {
  props: {
    economicId: {
      type: Number,
      default: 0
    },
    planId: {
      type: Number,
      default: 0
    },
    value: [String, Number]
  },
  data() {
    return {
      visible: false,
      data: [],
      columns: []
    };
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    }
  },
  async mounted() {
    const res = await this.$fetch('windfarm/economic/getSignPrice');
    const groups = groupBy(res.data.data, 'provinceName');
    // groups.map(gruop => );
    const keys = Object.keys(groups);
    this.columns = groups[keys[0]].reduce(
      (acc, item) => {
        acc.push({ prop: item.year.toString(), label: item.year.toString() });
        return acc;
      },
      [{ prop: 'name', label: '资源分区' }]
    );
    this.data = keys.map(key => {
      return groups[key].reduce(
        (acc, item) => {
          acc[item.year] = item.value;
          return acc;
        },
        { name: key }
      );
    });
  }
};
</script>
